import queryString from 'query-string';
import { get, del, post } from './apiUtils';

const defaultUrl = '/SubstanceClp/';

export default {
  getSubstanceClps: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
  deleteSubstanceClp: id => del(`${defaultUrl}${id}`),
  saveSubstanceClp: data => post(`${defaultUrl}`, data),
};
